<template>
	<tabs :options="{ useUrlFragment: false }" id="notification-tab">
		<br />
		<tab :name="notificationsTabName">
			<form class="form-inline">
				<div class="form-group" style="margin-bottom: 5px;">
					<font-awesome-icon icon="question-circle"
														 v-tooltip.top-center="{content: globalSettingToolTip, trigger:'hover click'}">
					</font-awesome-icon> {{ globalSettingText }}
					<select class="form-control" @change="$emit('changeGlobal', $event.target.value)">
						<option v-for="setting in options.GLOBAL_SETTINGS" :key="setting.GLOBAL_SETTING_CODE"
										:value="setting.GLOBAL_SETTING_CODE"
										:selected="setting.GLOBAL_SETTING_CODE === globalSetting">
							{{ setting.GLOBAL_SETTING_DESC }}
						</option>
					</select>
				</div>

				<!-- Shows the system default config data boxes -->
				<div class="col-md-6 col-sm-12 details-notification pull-right" v-show="globalSetting === 'S'">
					<span v-for="(option, systemOptionIndex) in options.WORKFLOW_SOURCES" :key="`display_${systemOptionIndex}`">
						<div class="row" style="margin-bottom: 5px;">
							<div class="col-xs-1" style="padding-top: 10px; padding-bottom: 10px; text-align: right;">
								<strong>
									{{ systemOptionIndex + 1 }})
								</strong>
							</div>
							<div class="panel-heading-notification col-xs-11">
								<strong style="margin-left: 5px;">
									<div class="method-name" style="display: inline; margin-right: 40px;" v-if="option.SOURCE_TYPE === 'email'">
										<font-awesome-icon icon="envelope" aria-hidden="true"></font-awesome-icon> {{ emailText }}
									</div>
									<div class="method-name" style="display: inline; margin-right: 15px;" v-if="option.SOURCE_TYPE === 'phone'">
										<font-awesome-icon icon="phone" aria-hidden="true"></font-awesome-icon> {{ voiceCallText }}
									</div>
									<div class="method-name" style="display: inline; margin-right: 50px;" v-if="option.SOURCE_TYPE === 'sms'">
										<font-awesome-icon icon="sms" aria-hidden="true"></font-awesome-icon> {{ smsText }}
									</div>
								</strong> {{ option.SOURCE_DESC }}
							</div>
						</div>
					</span>
				</div>
				<div class="row">
					<div class="col-md-10 padding-left-0">
						<strong>{{ notificationsText }}</strong>
					</div>
					<div class="col-md-2 padding-right-0" style="text-align: right;">
						<strong>
							{{ subscribedText }}
						</strong>
					</div>
				</div>
				<div class="row">
					<!-- System Default Selected Start -->
					<template v-if="globalSetting === 'S'">
						<template v-for="(type, index) in options.TYPES">
							<div :key="`system_default_options_${index}`">
								<div v-if="index"
										class="row row-striped workflow"
										:class="{'bottom-row-striped': +index + 1 === options.TYPES.length}"
										:key="`static_${type.NOTIFICATION_TYPE_ID}`">
									<div class="col-md-10">
										<p class="text-blue medium-text" v-html="getTitle(type)"></p>
									</div>
									
									<!-- Adjust index as first item in types is a default option which doesn't show in subscriptions -->
									<div class="col-md-2" v-if="!!preferences.SUBSCRIPTIONS[index]">
										<sapphire-toggle :value="preferences.SUBSCRIPTIONS[index].SUBSCRIBED_FLG"
																		v-model="preferences.SUBSCRIPTIONS[index].SUBSCRIBED_FLG"
																		@input="changedData(type.NOTIFICATION_TYPE_ID)"
																		:cssColors="true"
																		v-if="type.IS_CHECKABLE !== 'N'"
																		style="display: inline; float: right;">
										</sapphire-toggle>
									</div>
								</div>
							</div>
						</template>
					</template>
					<!-- System Default Selected End -->
					<!-- My Defualt Selected Start -->
					<template v-if="globalSetting === 'D'">
						<template v-for="(type, index) in options.TYPES">
							<panel-basic :id="'default_notification_workflow'"
													 :title="getTitle(type)"
													 :collapsable="true"
													 :useCollapseExpandCarrots="false"
													 class="no-after"
													 :key="`my_default_notifications_${index}`"
													 v-if="index === 0">
								<template v-slot:title>
									<span class="no-after" v-if="!!preferences.SUBSCRIPTIONS[index]">
										<span v-html="getTitle(type)"></span>
										<font-awesome-icon icon="info-circle"
																			 class="text-yellow"
																			 v-if="!!changedTypes[type.NOTIFICATION_TYPE_ID]">
										</font-awesome-icon>
									</span>
								</template>
								<step-panel v-for="(workflow, workflowIndex) in preferences.SUBSCRIPTIONS[index].WORKFLOWS"
														:workflow="workflow"
														:sources="options.WORKFLOW_SOURCES"
														:stepNumber="workflowIndex + 1"
														:addVoiceCallText="addVoiceCallText"
														:contactAtText="contactAtText"
														:addEmailText="addEmailText"
														:emailText="emailText"
														:smsTextMessage="smsTextMessage"
														:addSMSTextMessageText="addSMSTextMessageText"
														:voiceCallText="voiceCallText"
														@updateChange="changedData(type.NOTIFICATION_TYPE_ID)"
														:key="`workflow_step_${workflowIndex}`">
								</step-panel>
								<div class="row text-center">
									<button class="btn btn-default btn-gray"
													@click.prevent="addWorkFlow(type.NOTIFICATION_TYPE_ID, index)"
													:disabled="canAddWorkflow(preferences.SUBSCRIPTIONS[index].WORKFLOWS)">
										<font-awesome-icon icon="plus"></font-awesome-icon>&emsp;{{ addNewStepText }}
									</button>
								</div>
								<br />
							</panel-basic>
							<div :key="`system_default_options_${index}`">
								<div v-if="index"
										class="row row-striped workflow"
										:class="{'bottom-row-striped': +index + 1 === options.TYPES.length}"
										:key="`static_${type.NOTIFICATION_TYPE_ID}`">
									<div class="col-md-10">
										<p class="text-blue medium-text" v-html="getTitle(type)"></p>
									</div>
									<div class="col-md-2">
										<sapphire-toggle :value="preferences.SUBSCRIPTIONS[index].SUBSCRIBED_FLG"
																		 v-model="preferences.SUBSCRIPTIONS[index].SUBSCRIBED_FLG"
																		 @input="changedData(type.NOTIFICATION_TYPE_ID)"
																		 :cssColors="true"
																		 v-if="type.IS_CHECKABLE !== 'N'"
																		 style="display: inline; float: right;">
										</sapphire-toggle>
									</div>
								</div>
							</div>
						</template>
					</template>
					<!-- My Defualt Selected End -->
					<!-- Custom Selected Start -->
					<template v-if="globalSetting === 'C'">
						<panel-basic :id="'default_notification_workflow'"
												:title="getTitle(type)"
												:collapsable="true"
												:useCollapseExpandCarrots="false"
												class="no-after"
												v-for="(type, index) in options.TYPES" :key="`options_${index}`">
							<template v-slot:title>
								<span class="no-after" v-if="!!preferences.SUBSCRIPTIONS[index]">
									<span v-html="getTitle(type)"></span>
									<font-awesome-icon icon="info-circle"
																		 class="text-yellow"
																		 v-if="!!changedTypes[type.NOTIFICATION_TYPE_ID]">
									</font-awesome-icon>
									<sapphire-toggle :value="preferences.SUBSCRIPTIONS[index].SUBSCRIBED_FLG"
																	 v-model="preferences.SUBSCRIPTIONS[index].SUBSCRIBED_FLG"
																	 @input="changedData(type.NOTIFICATION_TYPE_ID, index)"
																	 :cssColors="true"
																	 v-if="type.IS_CHECKABLE !== 'N'"
																	 style="display: inline; float: right;">
									</sapphire-toggle>
								</span>
							</template>
							<step-panel v-for="(workflow, workflowIndex) in preferences.SUBSCRIPTIONS[index].WORKFLOWS"
													:workflow="workflow"
													:sources="options.WORKFLOW_SOURCES"
													:stepNumber="workflowIndex + 1"
													:addVoiceCallText="addVoiceCallText"
													:contactAtText="contactAtText"
													:addEmailText="addEmailText"
													:emailText="emailText"
													:smsTextMessage="smsTextMessage"
													:addSMSTextMessageText="addSMSTextMessageText"
													:voiceCallText="voiceCallText"
													@updateChange="changedData(type.NOTIFICATION_TYPE_ID)"
													:key="`workflow_step_${workflowIndex}`">
							</step-panel>
							<div class="row text-center">
								<button class="btn btn-default btn-gray margin-top-5"
												@click.prevent="addWorkFlow(type.NOTIFICATION_TYPE_ID, index)"
												:disabled="canAddWorkflow(preferences.SUBSCRIPTIONS[index].WORKFLOWS)">
									<font-awesome-icon icon="plus"></font-awesome-icon>&emsp;{{ addNewStepText }}
								</button>
							</div>
							<br />
						</panel-basic>
					</template>
					<!-- Custom Selected End -->
				</div>
				<h3>
					{{ languageSettinsText }}
				</h3>
				<div class="row">
					<div class="form-group col-md-7">
						<strong>
							{{ defaultVoiceText }}
						</strong>
						<select class="form-control" v-model="preferences.SETTINGS.VOICE_LANGUAGE" @input="setDirty">
							<option v-for="language in options.VOICE_LANGUAGES" :key="language.LANGUAGE_CODE" :value="language.LANGUAGE_CODE">
								{{ language.LANGUAGE_DESC }}
							</option>
						</select>
					</div>
				</div>
				<br />
				<div class="row">
					<div class="form-group col-md-7">
						<strong>
							{{ defaultSMSText }}
						</strong>
						<select class="form-control"
										v-model="preferences.SETTINGS.SMS_LANGUAGE"
										@input="setDirty">
							<option v-for="language in options.TEXT_LANGUAGES"
											:key="language.LANGUAGE_CODE"
											:value="language.LANGUAGE_CODE">
								{{ language.LANGUAGE_DESC }}
							</option>
						</select>
					</div>
				</div>
				<br />
				<div class="row">
					<div class="form-group col-md-7">
						<strong>
							{{ defaultEmailText }}
						</strong>
						<select class="form-control" v-model="preferences.SETTINGS.EMAIL_LANGUAGE" @input="setDirty">
							<option v-for="language in options.TEXT_LANGUAGES"
											:key="language.LANGUAGE_CODE"
											:value="language.LANGUAGE_CODE">
								{{ language.LANGUAGE_DESC }}
							</option>
						</select>
					</div>
				</div>
				<br />
			</form>
		</tab>
		<tab :name="broadcastsTabName">
			<broadcast-tab :broadcastsData="broadcastsData"
											:broadcastHistoryText="broadcastHistoryText"
											:noBroadcastMessage="noBroadcastMessage"
											:voiceCall="voiceCallText"
											:phoneText="phoneText"
											:answeredByText="answeredByText"
											:durationsText="durationsText"
											:phoneMessageText="phoneMessageText"
											:showEnglishText="showEnglishText"
											:noAudioSupportText="noAudioSupportText"
											:smsTextMessage="smsTextMessage"
											:smsTestMessageColon="smsTestMessageColon"
											:emailAllCaps="emailAllCaps"
											:emailWithColon="emailWithColon"
											:subjectLineWithColon="subjectLineWithColon">
			</broadcast-tab>
		</tab>
	</tabs>
</template>

<script>
	import { Tabs, Tab } from 'vue-tabs-component';
	import PanelBasic from '../panels/PanelBasic.vue';
	import SapphireToggle from '../SapphireToggle/SapphireToggle.vue';
	import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
	import { VTooltip, VPopover, VClosePopover } from 'v-tooltip';

	import StepPanel from './StepPanel.vue';
	import BroadcastTab from './BroadcastTab.vue';

	export default {
		name: 'SharedNotifications',
		props: {
			options: {
				type: Object,
				required: true
			},
			preferences: {
				type: Object,
				required: true
			},
			userType: {
				type: String,
				required: true
			},
			saveOnChange: {
				type: Boolean,
				default: false
			},
			globalSetting: {
				type: String,
				default: 'S'
			},
			broadcastsData: {
				type: Array,
				default: function() {
					return []
				}
			},
			globalSettingText: {
				type: String,
				default: 'Global Setting'
			},
			emailText: {
				type: String,
				default: 'Email'
			},
			voiceCallText: {
				type: String,
				default: 'Voice Call'
			},
			smsText: {
				type: String,
				default: 'SMS'
			},
			notificationsText: {
				type: String,
				default: 'Sapphire Notifications Subscriptions'
			},
			subscribedText: {
				type: String,
				default: 'Subscribed'
			},
			languageSettinsText: {
				type: String,
				default: 'Language Settings'
			},
			addNewStepText: {
				type: String,
				default: 'Add new step'
			},
			defaultVoiceText: {
				type: String,
				default: 'Default Voice Call Language:'
			},
			defaultSMSText: {
				type: String,
				default: 'Default SMS Text Language:'
			},
			defaultEmailText: {
				type: String,
				default: 'Default Email Message Language:'
			},
			broadcastHistoryText: {
				type: String,
				default: 'Broadcast History'
			},
			noBroadcastMessage: {
				type: String,
				default: 'No Broadcasts were found within the last 3 months'
			},
			phoneText: {
				type: String,
				default: 'Phone:'
			},
			answeredByText: {
				type: String,
				default: 'Answered by:'
			},
			durationsText: {
				type: String,
				default: 'Duration:'
			},
			phoneMessageText: {
				type: String,
				default: 'Phone Message:'
			},
			showEnglishText: {
				type: String,
				default: 'Show English'
			},
			noAudioSupportText: {
				type: String,
				default: 'Your browser does not support the audio element.'
			},
			smsTextMessage: {
				type: String,
				default: "SMS Text Message"
			},
			smsTestMessageColon: {
				type: String,
				default: 'SMS Text Message:'
			},
			emailAllCaps: {
				type: String,
				default: 'EMAIL'
			},
			emailWithColon: {
				type: String,
				default: 'Email:'
			},
			subjectLineWithColon: {
				type: String,
				default: 'Subject Line:'
			},
			notificationsTabName: {
				type: String,
				default: 'Notification Workflow'
			},
			broadcastsTabName: {
				type: String,
				default: 'My Broadcast History'
			},
			defaultWorkflowText: {
				type: String,
				default: 'Default Notification Workflow'
			},
			systemDefaultText: {
				type: String,
				default: 'System Default:'
			},
			systemDefaultMessageText: {
				type: String,
				default: "Workflow is based off of Sapphire's system default workflow setting."
			},
			myDefaultText: {
				type: String,
				default: "My Default:"
			},
			myDefaultMessageText: {
				type: String,
				default: "Workflow is based on user defined default subscription workflow."
			},
			customText: {
				type: String,
				default: "Custom:"
			},
			customMessageText: {
				type: String,
				default: "Workflow is customized per subscription type, if no workflow is supplied the system will fall back to the user's default and then the system default."
			},
			addVoiceCallText: {
				type: String,
				default: "Add Voice Call"
			},
			contactAtText: {
				type: String,
				default: "Contact at"
			},
			addEmailText: {
				type: String,
				default: "Add email"
			},
			addSMSTextMessageText: {
				type: String,
				default: "Add SMS Text Message"
			}
		},
		data() {
			return {
				steps: 0,
				changedTypes: {}
			};
		},
		components: {
			Tabs,
			Tab,
			PanelBasic,
			FontAwesomeIcon,
			StepPanel,
			SapphireToggle,
			BroadcastTab
		},
		directives: {
			'tooltip': VTooltip,
			'close-popover': VClosePopover,
			'v-popover': VPopover
		},
		methods: {
			changedData(id) {
				this.$set(this.changedTypes, id, true);
				this.$emit('setDirty');
			},
			getTitle(type) {
				let title = !!type.NOTIFICATION_TYPE_DESC ? type.NOTIFICATION_TYPE_DESC : this.defaultWorkflowText;

				return title;
			},
			setDirty() {
				this.$emit('setDirty');
			},
			addWorkFlow(id, index) {
				this.preferences.SUBSCRIPTIONS[index].WORKFLOWS.push({
					NOTIFICATION_TYPE_ID:	0,
					WORKFLOW_STEP:				1,
					WORKFLOW_STEP_METHOD:	'',
					WORKFLOW_STEP_PATH:		'',
					WORKFLOW_STEP_SOURCE:	'',
					STEPS:								[]
				});
				this.$emit('setDirty');
			},
			globalSettingToolTip() {
				return `
					<strong style="font-size: 14px;">${ this.systemDefaultText }</strong><br />
					${this.systemDefaultMessageText}<br />
					<strong style="font-size: 14px;">${ this.myDefaultText }</strong><br />
					${ this.myDefaultMessageText }<br />
					<strong style="font-size: 14px;">${ this.customText }</strong><br />
					${ this.customMessageText }
				`;
			},
			canAddWorkflow(workflows) {
				let disabled = false;

				if(!!workflows) {
					if(this.userType === 'student' && workflows.length > 1) {
						disabled = true;
					} else {
						if(workflows.length > 6) {
							disabled = true;
						}
					}
				}

				return disabled;
			},
		}
	}
</script>

<style scoped>
	.bottom-row-striped {
		border-bottom: 1.5px solid lightgray;
	}

	.padding-left-0 {
		padding-left: 0;
	}

	.padding-right-0 {
		padding-right: 0;
	}

	.panel-heading-notification {
		background-color: #20AEA3;
		padding-top: 10px;
		padding-left: 0;
		padding-bottom: 10px;
		color: #FFFFFF;
	}
</style>
